var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCube1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.779,
    height: 89.605,
    viewBox: "0 0 91.779 89.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182521",
    "data-name": "\\uADF8\\uB8F9 182521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182344",
    "data-name": "\\uADF8\\uB8F9 182344",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182196",
    "data-name": "\\uADF8\\uB8F9 182196",
    transform: "translate(64.399 29.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182189",
    "data-name": "\\uADF8\\uB8F9 182189",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182187",
    "data-name": "\\uADF8\\uB8F9 182187",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130680",
    "data-name": "\\uD328\\uC2A4 130680",
    d: "M306.628,366l14.021,7.812V357.349l-14.021-7.812Z",
    transform: "translate(-306.628 -349.538)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182188",
    "data-name": "\\uADF8\\uB8F9 182188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130681",
    "data-name": "\\uD328\\uC2A4 130681",
    d: "M320.287,373.691a.233.233,0,0,1-.115-.03l-14.021-7.812a.239.239,0,0,1-.123-.208V349.177a.239.239,0,0,1,.355-.209L320.4,356.78a.239.239,0,0,1,.122.209v16.465a.237.237,0,0,1-.238.238ZM306.5,365.5l13.544,7.546V357.128L306.5,349.582Z",
    transform: "translate(-306.028 -348.939)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182192",
    "data-name": "\\uADF8\\uB8F9 182192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182190",
    "data-name": "\\uADF8\\uB8F9 182190",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130682",
    "data-name": "\\uD328\\uC2A4 130682",
    d: "M306.628,338.7l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-306.628 -331.527)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182191",
    "data-name": "\\uADF8\\uB8F9 182191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130683",
    "data-name": "\\uD328\\uC2A4 130683",
    d: "M320.37,346.4a.239.239,0,0,1-.116-.03l-14.1-7.826a.24.24,0,0,1-.123-.208.237.237,0,0,1,.122-.208l12.8-7.174a.237.237,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.416l-12.8,7.173A.24.24,0,0,1,320.37,346.4Zm-13.615-8.065,13.613,7.554,12.312-6.9-13.614-7.555Z",
    transform: "translate(-306.028 -330.927)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182195",
    "data-name": "\\uADF8\\uB8F9 182195",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182193",
    "data-name": "\\uADF8\\uB8F9 182193",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130684",
    "data-name": "\\uD328\\uC2A4 130684",
    d: "M355.2,368.214l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-342.581 -351.227)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182194",
    "data-name": "\\uADF8\\uB8F9 182194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130685",
    "data-name": "\\uD328\\uC2A4 130685",
    d: "M342.219,374.825a.239.239,0,0,1-.239-.239v-16.63a.239.239,0,0,1,.121-.208l12.622-7.091a.238.238,0,0,1,.354.208v16.987a.239.239,0,0,1-.126.211L342.33,374.8A.233.233,0,0,1,342.219,374.825Zm.238-16.729v16.093l12.144-6.48V351.273Zm12.383,9.756h0Z",
    transform: "translate(-341.98 -350.627)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182206",
    "data-name": "\\uADF8\\uB8F9 182206",
    transform: "translate(11.775 57.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182199",
    "data-name": "\\uADF8\\uB8F9 182199",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182197",
    "data-name": "\\uADF8\\uB8F9 182197",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130686",
    "data-name": "\\uD328\\uC2A4 130686",
    d: "M174.161,436.97l14.021,7.812V428.317L174.161,420.5Z",
    transform: "translate(-174.161 -420.505)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182198",
    "data-name": "\\uADF8\\uB8F9 182198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130687",
    "data-name": "\\uD328\\uC2A4 130687",
    d: "M187.821,444.658a.245.245,0,0,1-.116-.03l-14.021-7.812a.239.239,0,0,1-.122-.209V420.143a.238.238,0,0,1,.354-.208l14.021,7.812a.238.238,0,0,1,.123.208V444.42a.239.239,0,0,1-.118.206A.243.243,0,0,1,187.821,444.658Zm-13.783-8.19,13.544,7.546V428.1l-13.544-7.546Z",
    transform: "translate(-173.561 -419.905)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182202",
    "data-name": "\\uADF8\\uB8F9 182202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182200",
    "data-name": "\\uADF8\\uB8F9 182200",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130688",
    "data-name": "\\uD328\\uC2A4 130688",
    d: "M174.161,409.668l14.1,7.826,12.8-7.173-14.1-7.826Z",
    transform: "translate(-174.161 -402.495)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182201",
    "data-name": "\\uADF8\\uB8F9 182201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130689",
    "data-name": "\\uD328\\uC2A4 130689",
    d: "M187.9,417.371a.23.23,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.416l12.8-7.173a.237.237,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.416l-12.8,7.174A.248.248,0,0,1,187.9,417.371Zm-13.614-8.066L187.9,416.86l12.311-6.9L186.6,402.406Z",
    transform: "translate(-173.561 -401.895)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182205",
    "data-name": "\\uADF8\\uB8F9 182205",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182203",
    "data-name": "\\uADF8\\uB8F9 182203",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130690",
    "data-name": "\\uD328\\uC2A4 130690",
    d: "M222.733,439.182l-12.621,6.735v-16.63l12.621-7.091Z",
    transform: "translate(-210.112 -422.195)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182204",
    "data-name": "\\uADF8\\uB8F9 182204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130691",
    "data-name": "\\uD328\\uC2A4 130691",
    d: "M209.75,445.793a.229.229,0,0,1-.122-.035.237.237,0,0,1-.116-.2v-16.63a.236.236,0,0,1,.122-.207l12.621-7.092a.238.238,0,0,1,.355.208V438.82a.237.237,0,0,1-.126.211l-12.621,6.735A.243.243,0,0,1,209.75,445.793Zm.238-16.729v16.093l12.144-6.479V422.241Zm12.383,9.755h0Z",
    transform: "translate(-209.512 -421.594)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182216",
    "data-name": "\\uADF8\\uB8F9 182216",
    transform: "translate(45.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182209",
    "data-name": "\\uADF8\\uB8F9 182209",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182207",
    "data-name": "\\uADF8\\uB8F9 182207",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130692",
    "data-name": "\\uD328\\uC2A4 130692",
    d: "M259.521,292.024l14.021,7.812V283.371l-14.021-7.812Z",
    transform: "translate(-259.521 -275.559)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182208",
    "data-name": "\\uADF8\\uB8F9 182208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130693",
    "data-name": "\\uD328\\uC2A4 130693",
    d: "M273.18,299.712a.235.235,0,0,1-.116-.03l-14.021-7.812a.238.238,0,0,1-.122-.208V275.2a.238.238,0,0,1,.354-.208L273.3,282.8a.237.237,0,0,1,.123.208v16.465a.237.237,0,0,1-.238.238Zm-13.783-8.19,13.545,7.546V283.149L259.4,275.6Z",
    transform: "translate(-258.921 -274.959)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182212",
    "data-name": "\\uADF8\\uB8F9 182212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182210",
    "data-name": "\\uADF8\\uB8F9 182210",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130694",
    "data-name": "\\uD328\\uC2A4 130694",
    d: "M259.521,264.723l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-259.521 -257.549)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182211",
    "data-name": "\\uADF8\\uB8F9 182211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130695",
    "data-name": "\\uD328\\uC2A4 130695",
    d: "M273.262,272.426a.242.242,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.416l12.8-7.173a.239.239,0,0,1,.233,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.243.243,0,0,1,273.262,272.426Zm-13.614-8.065,13.614,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-258.921 -256.949)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182215",
    "data-name": "\\uADF8\\uB8F9 182215",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182213",
    "data-name": "\\uADF8\\uB8F9 182213",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130696",
    "data-name": "\\uD328\\uC2A4 130696",
    d: "M308.093,294.236l-12.622,6.734V284.34l12.622-7.091Z",
    transform: "translate(-295.472 -277.249)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182214",
    "data-name": "\\uADF8\\uB8F9 182214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130697",
    "data-name": "\\uD328\\uC2A4 130697",
    d: "M295.11,300.847a.239.239,0,0,1-.239-.238v-16.63a.237.237,0,0,1,.122-.208l12.621-7.091a.238.238,0,0,1,.356.208v16.987a.237.237,0,0,1-.127.211l-12.621,6.734A.242.242,0,0,1,295.11,300.847Zm.238-16.729v16.093l12.145-6.48V277.295Zm12.383,9.756h0Z",
    transform: "translate(-294.871 -276.649)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182226",
    "data-name": "\\uADF8\\uB8F9 182226",
    transform: "translate(0 21.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182219",
    "data-name": "\\uADF8\\uB8F9 182219",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182217",
    "data-name": "\\uADF8\\uB8F9 182217",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130698",
    "data-name": "\\uD328\\uC2A4 130698",
    d: "M144.521,345.841l14.021,7.812V337.188l-14.021-7.812Z",
    transform: "translate(-144.521 -329.377)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182218",
    "data-name": "\\uADF8\\uB8F9 182218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130699",
    "data-name": "\\uD328\\uC2A4 130699",
    d: "M158.18,353.53a.236.236,0,0,1-.116-.03l-14.021-7.812a.238.238,0,0,1-.122-.209V329.015a.238.238,0,0,1,.354-.209l14.022,7.812a.239.239,0,0,1,.122.209v16.464a.239.239,0,0,1-.238.239ZM144.4,345.34l13.544,7.546V336.967L144.4,329.421Z",
    transform: "translate(-143.921 -328.777)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182222",
    "data-name": "\\uADF8\\uB8F9 182222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182220",
    "data-name": "\\uADF8\\uB8F9 182220",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130700",
    "data-name": "\\uD328\\uC2A4 130700",
    d: "M144.521,318.54l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-144.521 -311.367)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182221",
    "data-name": "\\uADF8\\uB8F9 182221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130701",
    "data-name": "\\uD328\\uC2A4 130701",
    d: "M158.262,326.243a.244.244,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.174a.239.239,0,0,1,.232,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.236.236,0,0,1,158.262,326.243Zm-13.614-8.066,13.613,7.555,12.311-6.9-13.614-7.554Z",
    transform: "translate(-143.921 -310.767)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182225",
    "data-name": "\\uADF8\\uB8F9 182225",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182223",
    "data-name": "\\uADF8\\uB8F9 182223",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130702",
    "data-name": "\\uD328\\uC2A4 130702",
    d: "M193.093,348.054l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-180.473 -331.066)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182224",
    "data-name": "\\uADF8\\uB8F9 182224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130703",
    "data-name": "\\uD328\\uC2A4 130703",
    d: "M180.111,354.664a.236.236,0,0,1-.123-.034.238.238,0,0,1-.115-.2V337.8a.239.239,0,0,1,.121-.208l12.621-7.091a.239.239,0,0,1,.356.208v16.988a.238.238,0,0,1-.127.21l-12.621,6.734A.237.237,0,0,1,180.111,354.664Zm.238-16.729v16.093l12.144-6.479V331.112Zm12.382,9.757h0Z",
    transform: "translate(-179.873 -330.466)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182236",
    "data-name": "\\uADF8\\uB8F9 182236",
    transform: "translate(53.29 56.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182229",
    "data-name": "\\uADF8\\uB8F9 182229",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182227",
    "data-name": "\\uADF8\\uB8F9 182227",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130704",
    "data-name": "\\uD328\\uC2A4 130704",
    d: "M278.667,433.543l14.021,7.812V424.889l-14.021-7.812Z",
    transform: "translate(-278.667 -417.077)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182228",
    "data-name": "\\uADF8\\uB8F9 182228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130705",
    "data-name": "\\uD328\\uC2A4 130705",
    d: "M292.326,441.231a.232.232,0,0,1-.116-.031l-14.021-7.812a.237.237,0,0,1-.123-.207V416.716a.238.238,0,0,1,.354-.208l14.021,7.812a.236.236,0,0,1,.122.207v16.465a.239.239,0,0,1-.238.238Zm-13.783-8.191,13.544,7.546V424.668l-13.544-7.547Z",
    transform: "translate(-278.066 -416.478)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182232",
    "data-name": "\\uADF8\\uB8F9 182232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182230",
    "data-name": "\\uADF8\\uB8F9 182230",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130706",
    "data-name": "\\uD328\\uC2A4 130706",
    d: "M278.667,406.241l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-278.667 -399.067)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182231",
    "data-name": "\\uADF8\\uB8F9 182231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130707",
    "data-name": "\\uD328\\uC2A4 130707",
    d: "M292.408,413.944a.242.242,0,0,1-.115-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.174a.239.239,0,0,1,.233,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.241.241,0,0,1,292.408,413.944Zm-13.614-8.066,13.614,7.554,12.311-6.9-13.613-7.554Z",
    transform: "translate(-278.066 -398.468)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182235",
    "data-name": "\\uADF8\\uB8F9 182235",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182233",
    "data-name": "\\uADF8\\uB8F9 182233",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130708",
    "data-name": "\\uD328\\uC2A4 130708",
    d: "M327.239,435.755l-12.622,6.734v-16.63l12.622-7.092Z",
    transform: "translate(-314.617 -418.768)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182234",
    "data-name": "\\uADF8\\uB8F9 182234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130709",
    "data-name": "\\uD328\\uC2A4 130709",
    d: "M314.256,442.366a.229.229,0,0,1-.122-.035.236.236,0,0,1-.116-.2V425.5a.237.237,0,0,1,.122-.207l12.621-7.092a.238.238,0,0,1,.356.208v16.987a.238.238,0,0,1-.126.211l-12.621,6.734A.242.242,0,0,1,314.256,442.366Zm.239-16.729v16.093l12.145-6.48V418.814Zm12.383,9.756h0Z",
    transform: "translate(-314.018 -418.168)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182246",
    "data-name": "\\uADF8\\uB8F9 182246",
    transform: "translate(30.435 28.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182239",
    "data-name": "\\uADF8\\uB8F9 182239",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182237",
    "data-name": "\\uADF8\\uB8F9 182237",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130710",
    "data-name": "\\uD328\\uC2A4 130710",
    d: "M221.135,363.127l14.021,7.812V354.474l-14.021-7.812Z",
    transform: "translate(-221.135 -346.662)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182238",
    "data-name": "\\uADF8\\uB8F9 182238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130711",
    "data-name": "\\uD328\\uC2A4 130711",
    d: "M234.794,370.816a.236.236,0,0,1-.116-.03l-14.021-7.812a.239.239,0,0,1-.123-.208V346.3a.237.237,0,0,1,.118-.205.241.241,0,0,1,.237,0L234.91,353.9a.239.239,0,0,1,.122.209v16.465a.238.238,0,0,1-.238.238Zm-13.783-8.19,13.545,7.546V354.254l-13.545-7.546Z",
    transform: "translate(-220.534 -346.064)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182242",
    "data-name": "\\uADF8\\uB8F9 182242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182240",
    "data-name": "\\uADF8\\uB8F9 182240",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130712",
    "data-name": "\\uD328\\uC2A4 130712",
    d: "M221.135,335.826l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-221.135 -328.652)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182241",
    "data-name": "\\uADF8\\uB8F9 182241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130713",
    "data-name": "\\uD328\\uC2A4 130713",
    d: "M234.876,343.529a.241.241,0,0,1-.116-.03l-14.1-7.826a.241.241,0,0,1-.123-.208.238.238,0,0,1,.122-.208l12.8-7.174a.238.238,0,0,1,.232,0l14.1,7.826a.236.236,0,0,1,.123.208.24.24,0,0,1-.122.209l-12.8,7.173A.241.241,0,0,1,234.876,343.529Zm-13.614-8.065,13.614,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-220.534 -328.052)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182245",
    "data-name": "\\uADF8\\uB8F9 182245",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182243",
    "data-name": "\\uADF8\\uB8F9 182243",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130714",
    "data-name": "\\uD328\\uC2A4 130714",
    d: "M269.708,365.34l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-257.087 -348.352)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182244",
    "data-name": "\\uADF8\\uB8F9 182244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130715",
    "data-name": "\\uD328\\uC2A4 130715",
    d: "M256.725,371.95a.239.239,0,0,1-.239-.238v-16.63a.239.239,0,0,1,.122-.208l12.621-7.091a.238.238,0,0,1,.355.208v16.988a.24.24,0,0,1-.126.211l-12.621,6.734A.238.238,0,0,1,256.725,371.95Zm.238-16.729v16.093l12.145-6.48V348.4Zm12.383,9.757h0Z",
    transform: "translate(-256.486 -347.752)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182256",
    "data-name": "\\uADF8\\uB8F9 182256",
    transform: "translate(25.271 48.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182249",
    "data-name": "\\uADF8\\uB8F9 182249",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182247",
    "data-name": "\\uADF8\\uB8F9 182247",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130716",
    "data-name": "\\uD328\\uC2A4 130716",
    d: "M208.134,415.136l14.02,7.812V406.483l-14.02-7.812Z",
    transform: "translate(-208.134 -398.671)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182248",
    "data-name": "\\uADF8\\uB8F9 182248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130717",
    "data-name": "\\uD328\\uC2A4 130717",
    d: "M221.793,422.824a.243.243,0,0,1-.116-.03l-14.021-7.812a.239.239,0,0,1-.122-.209V398.309a.238.238,0,0,1,.354-.209l14.021,7.813a.238.238,0,0,1,.122.208v16.464a.238.238,0,0,1-.118.206A.241.241,0,0,1,221.793,422.824Zm-13.783-8.19,13.544,7.546V406.261l-13.544-7.546Z",
    transform: "translate(-207.534 -398.071)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182252",
    "data-name": "\\uADF8\\uB8F9 182252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182250",
    "data-name": "\\uADF8\\uB8F9 182250",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130718",
    "data-name": "\\uD328\\uC2A4 130718",
    d: "M208.134,387.834l14.1,7.827,12.8-7.174-14.1-7.826Z",
    transform: "translate(-208.134 -380.661)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182251",
    "data-name": "\\uADF8\\uB8F9 182251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130719",
    "data-name": "\\uD328\\uC2A4 130719",
    d: "M221.875,395.538a.235.235,0,0,1-.116-.031l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.173a.24.24,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.416l-12.8,7.174A.24.24,0,0,1,221.875,395.538Zm-13.615-8.066,13.614,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-207.534 -380.061)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182255",
    "data-name": "\\uADF8\\uB8F9 182255",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182253",
    "data-name": "\\uADF8\\uB8F9 182253",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130720",
    "data-name": "\\uD328\\uC2A4 130720",
    d: "M256.706,417.348l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-244.085 -400.36)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182254",
    "data-name": "\\uADF8\\uB8F9 182254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130721",
    "data-name": "\\uD328\\uC2A4 130721",
    d: "M243.723,423.959a.233.233,0,0,1-.123-.035.238.238,0,0,1-.116-.2V407.09a.239.239,0,0,1,.122-.208l12.621-7.091a.238.238,0,0,1,.355.208v16.987a.236.236,0,0,1-.126.21l-12.621,6.735A.244.244,0,0,1,243.723,423.959Zm.238-16.729v16.093l12.144-6.479V400.406Zm12.383,9.756h0Z",
    transform: "translate(-243.484 -399.76)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182266",
    "data-name": "\\uADF8\\uB8F9 182266",
    transform: "translate(15.028 37.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182259",
    "data-name": "\\uADF8\\uB8F9 182259",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182257",
    "data-name": "\\uADF8\\uB8F9 182257",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130722",
    "data-name": "\\uD328\\uC2A4 130722",
    d: "M182.351,385.26l14.021,7.812V376.608L182.351,368.8Z",
    transform: "translate(-182.351 -368.796)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182258",
    "data-name": "\\uADF8\\uB8F9 182258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130723",
    "data-name": "\\uD328\\uC2A4 130723",
    d: "M196.009,392.95a.242.242,0,0,1-.116-.03l-14.02-7.812a.239.239,0,0,1-.123-.209V368.435a.237.237,0,0,1,.118-.205.241.241,0,0,1,.237,0l14.021,7.812a.237.237,0,0,1,.123.208v16.465a.239.239,0,0,1-.118.206A.244.244,0,0,1,196.009,392.95Zm-13.783-8.19,13.545,7.546V376.387l-13.545-7.546Z",
    transform: "translate(-181.75 -368.197)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182262",
    "data-name": "\\uADF8\\uB8F9 182262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182260",
    "data-name": "\\uADF8\\uB8F9 182260",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130724",
    "data-name": "\\uD328\\uC2A4 130724",
    d: "M182.351,357.96l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-182.351 -350.786)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182261",
    "data-name": "\\uADF8\\uB8F9 182261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130725",
    "data-name": "\\uD328\\uC2A4 130725",
    d: "M196.092,365.663a.243.243,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.173a.238.238,0,0,1,.232,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.239.239,0,0,1,196.092,365.663ZM182.478,357.6l13.613,7.554,12.311-6.9L194.789,350.7Z",
    transform: "translate(-181.75 -350.186)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182265",
    "data-name": "\\uADF8\\uB8F9 182265",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182263",
    "data-name": "\\uADF8\\uB8F9 182263",
    transform: "translate(0.238 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130726",
    "data-name": "\\uD328\\uC2A4 130726",
    d: "M230.923,387.473,218.3,394.208v-16.63l12.622-7.092Z",
    transform: "translate(-218.302 -370.486)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182264",
    "data-name": "\\uADF8\\uB8F9 182264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130727",
    "data-name": "\\uD328\\uC2A4 130727",
    d: "M217.94,394.084a.233.233,0,0,1-.122-.035.237.237,0,0,1-.116-.2v-16.63a.239.239,0,0,1,.122-.208l12.621-7.091a.239.239,0,0,1,.356.208v16.987a.238.238,0,0,1-.126.21l-12.621,6.734A.242.242,0,0,1,217.94,394.084Zm.238-16.729v16.093l12.145-6.479V370.531Zm12.383,9.756h0Z",
    transform: "translate(-217.702 -369.885)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182276",
    "data-name": "\\uADF8\\uB8F9 182276",
    transform: "translate(46.465 37.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182269",
    "data-name": "\\uADF8\\uB8F9 182269",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182267",
    "data-name": "\\uADF8\\uB8F9 182267",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130728",
    "data-name": "\\uD328\\uC2A4 130728",
    d: "M261.484,385.662l14.021,7.812V377.008L261.484,369.2Z",
    transform: "translate(-261.484 -369.197)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182268",
    "data-name": "\\uADF8\\uB8F9 182268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130729",
    "data-name": "\\uD328\\uC2A4 130729",
    d: "M275.144,393.35a.244.244,0,0,1-.116-.029l-14.021-7.812a.238.238,0,0,1-.123-.208V368.835a.238.238,0,0,1,.118-.206.241.241,0,0,1,.237,0l14.021,7.812a.238.238,0,0,1,.122.208v16.465a.237.237,0,0,1-.238.238Zm-13.783-8.19,13.544,7.546V376.787l-13.544-7.546Z",
    transform: "translate(-260.885 -368.597)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182272",
    "data-name": "\\uADF8\\uB8F9 182272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182270",
    "data-name": "\\uADF8\\uB8F9 182270",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130730",
    "data-name": "\\uD328\\uC2A4 130730",
    d: "M261.484,358.36l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-261.484 -351.186)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182271",
    "data-name": "\\uADF8\\uB8F9 182271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130731",
    "data-name": "\\uD328\\uC2A4 130731",
    d: "M275.227,366.063a.239.239,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.174a.24.24,0,0,1,.232,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.237.237,0,0,1,275.227,366.063ZM261.613,358l13.613,7.554,12.311-6.9L273.923,351.1Z",
    transform: "translate(-260.885 -350.587)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182275",
    "data-name": "\\uADF8\\uB8F9 182275",
    transform: "translate(14.283 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182273",
    "data-name": "\\uADF8\\uB8F9 182273",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130732",
    "data-name": "\\uD328\\uC2A4 130732",
    d: "M310.058,387.874l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-297.438 -370.887)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182274",
    "data-name": "\\uADF8\\uB8F9 182274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130733",
    "data-name": "\\uD328\\uC2A4 130733",
    d: "M297.076,394.485a.238.238,0,0,1-.238-.238v-16.63a.24.24,0,0,1,.121-.208l12.621-7.092a.239.239,0,0,1,.356.208v16.987a.238.238,0,0,1-.127.21l-12.621,6.734A.234.234,0,0,1,297.076,394.485Zm.239-16.729v16.093l12.144-6.48V370.932Zm12.382,9.756h0Z",
    transform: "translate(-296.838 -370.286)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182286",
    "data-name": "\\uADF8\\uB8F9 182286",
    transform: "translate(31.331 52.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182279",
    "data-name": "\\uADF8\\uB8F9 182279",
    transform: "translate(0 7.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182277",
    "data-name": "\\uADF8\\uB8F9 182277",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130734",
    "data-name": "\\uD328\\uC2A4 130734",
    d: "M223.39,424.032l14.021,7.812V415.38l-14.021-7.812Z",
    transform: "translate(-223.39 -407.567)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182278",
    "data-name": "\\uADF8\\uB8F9 182278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130735",
    "data-name": "\\uD328\\uC2A4 130735",
    d: "M237.049,431.721a.237.237,0,0,1-.116-.03l-14.021-7.812a.237.237,0,0,1-.123-.208V407.206a.239.239,0,0,1,.355-.208l14.021,7.812a.238.238,0,0,1,.122.209v16.464a.238.238,0,0,1-.118.205A.243.243,0,0,1,237.049,431.721Zm-13.783-8.19,13.545,7.546V415.158l-13.545-7.546Z",
    transform: "translate(-222.789 -406.967)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182282",
    "data-name": "\\uADF8\\uB8F9 182282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182280",
    "data-name": "\\uADF8\\uB8F9 182280",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130736",
    "data-name": "\\uD328\\uC2A4 130736",
    d: "M223.39,396.731l14.1,7.827,12.8-7.174-14.1-7.826Z",
    transform: "translate(-223.39 -389.558)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182281",
    "data-name": "\\uADF8\\uB8F9 182281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130737",
    "data-name": "\\uD328\\uC2A4 130737",
    d: "M237.131,404.434a.236.236,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.174a.241.241,0,0,1,.232,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.237.237,0,0,1,237.131,404.434Zm-13.614-8.066,13.613,7.555,12.311-6.9-13.614-7.554Z",
    transform: "translate(-222.789 -388.958)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182285",
    "data-name": "\\uADF8\\uB8F9 182285",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182283",
    "data-name": "\\uADF8\\uB8F9 182283",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130738",
    "data-name": "\\uD328\\uC2A4 130738",
    d: "M271.964,426.244l-12.621,6.735v-16.63l12.621-7.092Z",
    transform: "translate(-259.343 -409.257)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182284",
    "data-name": "\\uADF8\\uB8F9 182284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130739",
    "data-name": "\\uD328\\uC2A4 130739",
    d: "M258.979,432.855a.23.23,0,0,1-.122-.035.236.236,0,0,1-.116-.2v-16.63a.239.239,0,0,1,.122-.208l12.621-7.092a.24.24,0,0,1,.237,0,.237.237,0,0,1,.118.206v16.987a.238.238,0,0,1-.126.211l-12.621,6.734A.242.242,0,0,1,258.979,432.855Zm.238-16.729V432.22l12.145-6.48V409.3Zm12.383,9.756h0Z",
    transform: "translate(-258.741 -408.657)",
    fill: "#111"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCube1);
export default __webpack_public_path__ + "static/media/information_cube1.1f8e1d12ddb185393f781a82bc7ff9b7.svg";
export { ForwardRef as ReactComponent };